export enum AccountPayablesErrorOrigin {
    GET_EXPENDITURE_RECORDS = 'GET_EXPENDITURE_RECORDS',
    CREATE_EXPENDITURE_RECORD = 'CREATE_EXPENDITURE_RECORD',
    GET_PAYABLE_CONTRACT_DEBITS = 'GET_PAYABLE_CONTRACT_DEBITS',
    GET_PAYABLE_DEBIT_BY_ID = 'GET_PAYABLE_DEBIT_BY_ID',
    CREATE_PAYABLE_PAYMENT = 'CREATE_PAYABLE_PAYMENT',
    GET_PAYABLE_CONTRACT_PAYMENTS = 'GET_PAYABLE_DEBIT_BY_ID',
    DELETE_PAYABLE_CONTRACT_DEBIT = 'DELETE_PAYABLE_CONTRACT_DEBIT',
}

export interface AccountPayablesError {
    type: AccountPayablesErrorOrigin,
    detail: any
}